import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const runPayrollCreateService = (
  params: Types.RunPayrollCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const runPayrollCheckRuleService = (
  params: Types.RunPayrollCheckRuleRequest
) =>
  RestAPIClient.call<Types.RunPayrollCheckRuleResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.CheckRule,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const runPayrollLockDataAllService = (
  params: Types.RunPayrollLockDataRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.LockData,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const runPayrollLockDataUpdateService = (
  params: Types.RunPayrollLockDataUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.LockData,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const runPayrollCheckLockDataService = (
  params: Types.RunPayrollCheckLockDataRequest
) =>
  RestAPIClient.call<Types.RunPayrollCheckLockDataResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.LockData,
    config: {
      requireAuthentication: true,
      params,
    },
  });
